export default __webpack_public_path__ + "static/media/vip-11.dd707884.gif";